import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Container,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from '@mui/material';
import React, { useState } from 'react';

function WendlerBBBPlan({ oneRepMaxes }) {
    const [trainingDays, setTrainingDays] = useState(3);
    const [selectedWeek, setSelectedWeek] = useState(1);

    const handleTrainingDays = (event, newTrainingDays) => {
        if (newTrainingDays !== null) {
            setTrainingDays(newTrainingDays);
        }
    };

    const handleWeekChange = (event, newWeek) => {
        if (newWeek !== null) {
            setSelectedWeek(newWeek);
        }
    };

    const calculateWeight = (oneRM, percentage) => Math.ceil((oneRM * percentage) / 2.5) * 2.5;

    const trainingSchedule = [
        ['squat', 'benchPress', 'deadlift'], // 3-Tage Woche
        ['squat', 'benchPress', 'deadlift', 'overheadPress'] // 4-Tage Woche
    ];

    const weeks = [
        { week: 1, main: [0.65, 0.75, 0.85], bbb: 0.5, reps: [5, 5, '5+'], warmup: [0.4, 0.5, 0.6] },
        { week: 2, main: [0.7, 0.8, 0.9], bbb: 0.5, reps: [3, 3, '3+'], warmup: [0.4, 0.5, 0.6] },
        { week: 3, main: [0.75, 0.85, 0.95], bbb: 0.5, reps: [5, 3, '1+'], warmup: [0.4, 0.5, 0.6] },
        { week: 4, main: [0.4, 0.5, 0.6], bbb: 0.5, reps: [5, 5, 5], warmup: [0.4, 0.5, 0.6] }
    ];

    if (!oneRepMaxes) {
        return (
            <Container>
                <Typography variant="h6" gutterBottom>
                    Bitte berechne zuerst die 1RMs.
                </Typography>
            </Container>
        );
    }

    return (
        <>
            <hr></hr>
            <Typography align='center' style={{ marginTop: 2 }} variant='h6'>Intervall</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                <ToggleButtonGroup
                    color="primary"
                    value={trainingDays}
                    exclusive
                    onChange={handleTrainingDays}
                    aria-label="Training days per week"
                    sx={{ width: '100%', mb: 2 }}
                    fullWidth
                >
                    <ToggleButton value={3}>3 Tage</ToggleButton>
                    <ToggleButton value={4}>4 Tage</ToggleButton>
                </ToggleButtonGroup>
                <Typography align='center' style={{ marginTop: 2 }} variant='h6'>Trainingswoche</Typography>
                <ToggleButtonGroup
                    color="primary"
                    value={selectedWeek}
                    exclusive
                    onChange={handleWeekChange}
                    aria-label="Select week"
                    sx={{ width: '100%', mb: 2 }}
                    fullWidth
                >
                    {weeks.map((week) => (
                        <ToggleButton key={week.week} value={week.week}>{`Woche ${week.week}`}</ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Box>
            {trainingSchedule[trainingDays - 3].map((exercise, dayIndex) => {
                const week = weeks.find((w) => w.week === selectedWeek);

                return (
                    <Accordion key={`week-${week.week}-day-${dayIndex + 1}`}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Woche {week.week}, Tag {dayIndex + 1} - {exercise.toUpperCase()}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Phase</TableCell>
                                            <TableCell align="right">Sätze x Wiederholungen</TableCell>
                                            <TableCell align="right">Gewicht (%)</TableCell>
                                            <TableCell align="right">Gewicht (kg)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {[...week.warmup, ...week.main].map((percent, index) => (
                                            <TableRow key={`${exercise}-${index}`}>
                                                <TableCell component="th" scope="row">
                                                    {index < week.warmup.length ? 'Aufwärmen' : 'Haupt'}
                                                </TableCell>
                                                <TableCell align="right">{index >= week.warmup.length ? week.reps[index - week.warmup.length] : '5'}</TableCell>
                                                <TableCell align="right">{`${Math.round(percent * 100)}%`}</TableCell>
                                                <TableCell align="right">{calculateWeight(oneRepMaxes[exercise], percent)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell>BBB</TableCell>
                                            <TableCell align="right">5 x 10</TableCell>
                                            <TableCell align="right">{`${week.bbb * 100}%`}</TableCell>
                                            <TableCell align="right">{calculateWeight(oneRepMaxes[exercise], week.bbb)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </>
    );
}

export default WendlerBBBPlan;
